import { Theme } from '@mui/material'

const useStyles = {
  backdrop: {
    backgroundColor: 'white',
    width: '100%',
    height: '100%',
    zIndex: 0,
    position: 'fixed',
  },
  dialogHeader: {
    padding: 2,
  },
  form: {
    display: 'flex' as const,
    flexGrow: 1,
    flexDirection: 'column' as const,
  },
  mainContainer: {
    gap: 3,
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
  },
  loadingContainer: {
    marginTop: '32px',
    textAlign: 'center',
  },
  formContent: {
    gap: 1,
    flexDirection: 'column',
    flexGrow: 1,
  },
  radioGroup: (theme: Theme) => ({
    gap: theme.spacing(1),
  }),
  radioFrom: {
    width: '90px',
  },
  dateRangeContainer: (theme: Theme) => ({
    flex: '1',
    '& .MuiMultiInputDateRangeField-root': {
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
        rowGap: theme.spacing(2),
      },
    },
    '& .MuiMultiInputDateRangeField-separator': {
      marginRight: theme.spacing(2),
    },
    '& .MuiPickersTextField-root': {
      maxWidth: '164px',
      '&:last-child': {
        marginLeft: 0,
      },
    },
  }),
  spacer: {
    flexGrow: 1,
  },
  actionButtons: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 2,
    gap: '10px',
  },
  pauseButton: {
    width: '160px',
  },
}

export default useStyles
